import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface UseArticleDataProps {
  id?: string;
  isSpecial?: boolean;
  isEditMode: boolean;
}

export const useArticleData = ({ id, isSpecial, isEditMode }: UseArticleDataProps) => {
  return useQuery({
    queryKey: ["article", id, isSpecial],
    queryFn: async () => {
      if (!id) {
        console.log("No ID provided");
        return null;
      }
      
      const table = isSpecial ? "special_articles" : "articles";
      console.log(`Fetching ${isSpecial ? 'special' : 'regular'} article:`, {
        table,
        id,
        isEditMode
      });

      const { data, error } = await supabase
        .from(table)
        .select("*")
        .eq("id", id)
        .maybeSingle();

      if (error) {
        console.error("Error fetching article:", error);
        throw error;
      }

      console.log("Found article:", data);
      return data;
    },
    enabled: !!id && isEditMode,
  });
};